import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawEyeSlashIcon from "./RawEyeSlashIcon.svg.jsx";

const EyeSlashIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawEyeSlashIcon} {...props} />;
});

export default EyeSlashIcon;
